import ContratTemplateUseConvention from '@/generated/controls/contratTemplate/ContratTemplateUseConvention.vue';
import { defineComponent } from 'vue';

export default defineComponent({
  components: {},
  extends: ContratTemplateUseConvention
})
